import { combineReducers } from 'redux';
import { SELECT_ORGANISATION, ORGANISATION_INITIALISE } from '../actions';
import { ADMIN_COMPLETE_SETUP_STEP, ORGANISATION_UPDATE_ORGANISATION } from '../../admin/actions';
import { LEARNING_UPDATE_ONBOARDING_SETTINGS } from '../../learning/actions';
import networks from './networks';
import admins from './admins';
import functions from './functions';
import channels from './channels';
import users from './users';
import roles from './roles';
import teams from './teams';

const initialised = (state = null, action) => {
  switch (action.type) {
    case SELECT_ORGANISATION:
      return action.organisationId;
    case ORGANISATION_INITIALISE:
      return action.organisation.id || null;
    default:
      return state;
  }
};

const selected = (state = null, action) => {
  switch (action.type) {
    case ORGANISATION_INITIALISE:
    case ORGANISATION_UPDATE_ORGANISATION:
      return {
        ...state,
        ...action.organisation
      };
    case LEARNING_UPDATE_ONBOARDING_SETTINGS: {
      if (!state) return state;
      const payload = action.payload || {};
      const forceChronologicalCompletion = typeof payload.force_chronological_course_completion !== 'undefined'
        ? payload.force_chronological_course_completion
        : payload.force_chronological_completion;
      return {
        ...state,
        settings: {
          ...(state.settings || {}),
          ...(typeof payload.due_date_offset !== 'undefined'
            ? { onboarding_due_date_offset: payload.due_date_offset }
            : {}),
          ...(typeof forceChronologicalCompletion !== 'undefined'
            ? { onboarding_force_chronological_completion: forceChronologicalCompletion }
            : {}),
        }
      };
    }
    default: return state;
  }
};

const setup = (state = null, action) => {
  switch (action.type) {
    case ORGANISATION_INITIALISE:
      return action.setupProgress || null;
    case ADMIN_COMPLETE_SETUP_STEP:
      return { ...state, [action.step]: true };
    default:
      return state;
  }
};

const billing = (state = null, action) => {
  switch (action.type) {
    case ORGANISATION_INITIALISE:
      return action.billing;
    default:
      return state;
  }
};

const reducers = combineReducers({
  initialised,
  selected,
  networks,
  admins,
  functions,
  channels,
  users,
  roles,
  setup,
  billing,
  teams,
});

export default (state, action) => {
  switch (action.type) {
    case SELECT_ORGANISATION:
      const newState = {
        ...state,
        initialised: action.organisationId,
        selected: state.selected
      };
      return reducers(newState, action);
    default: return reducers(state, action);
  }
};
